import { addDoc, collection } from 'firebase/firestore';
import { auth, db } from '@/firebase';

export type OperationalErrorCategory = 'api' | 'pdf';

export async function logOperationalError(
  category: OperationalErrorCategory,
  errorCode: string
): Promise<void> {
  if (!auth.currentUser) return;

  try {
    await addDoc(collection(db, 'error_logs'), {
      category,
      errorCode: normalizeOperationalErrorCode(errorCode),
      timestamp: Date.now(),
    });
  } catch (error) {
    console.warn('[operational-error-log] error was not saved', error);
  }
}

export function normalizeOperationalErrorCode(value: string): string {
  const normalized = value
    .toLowerCase()
    .replace(/[^a-z0-9:_-]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 80);
  return normalized || 'unknown_error';
}
